import Vue from "vue"
/* import stylesApi from "../../api/styles" */
import utilsApi from "../../api/utils"
const initialObject = {
  _id: undefined,
  name: undefined,
  style_order: undefined,
  body: undefined,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const objectFieldsToSend = ["name", "style_order", "body", "status", "_id"]
const objectToSend = (object) => {
  return Object.keys(object)
    .filter((key) => objectFieldsToSend.includes(key))
    .reduce((obj, key) => {
      obj[key] = object[key]
      return obj
    }, {})
}
// general state for the site

const initialState = {
  styles: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  dataShape: [],
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  styles: (state) => state.styles,
  stylesIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  stylesError: (state) => state.error,
  styles_Object: (state) => state.object,
  styles_isNew: (state) => state.isNew,
  styles_selected: (state) => state.selected,
  styles_dataShape: (state) => state.dataShape
}
const actions = {
  async DELETE_styles({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("styles", object)
    if (apiResponse != null) {
      //commit("STYLES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_styles", state.page)
      return true
    } else {
      commit("STYLES_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_styles({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_styles", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_styles", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_stylesState({ commit }, payload) {
    commit("SET_styles", payload)
    return true
  },
  async UPDATE_styles({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.updateObject(
      "styles",
      objectToSend(object)
    )
    if (apiResponse != null) {
      commit("STYLES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_styles", state.page)
      return true
    } else {
      commit("STYLES_ERROR")
      return false
    }
  },
  async CREATE_styles({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject(
      "styles",
      objectToSend(object)
    )
    if (apiResponse != null) {
      commit("SET_styles", { param: "object", value: apiResponse.style })
      //commit("STYLES_SETTING", apiResponse)
      dispatch("FETCH_PAGE_styles", state.page)
      return true
    } else {
      commit("STYLES_ERROR")
      return false
    }
  },
  async FETCH_styles({ commit }) {
    let apiResponse = await utilsApi.getObjects("styles")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("STYLES_SETTING", apiResponse)
      return true
    } else {
      commit("STYLES_ERROR")
      return false
    }
  },

  async FETCH_PAGE_styles({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("styles", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("STYLES_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("STYLES_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_styles({ commit }, payload) {
    commit("SET_OBJECT_STYLE", payload)
    return true
  },
  CLEAN_OBJECT_styles({ commit }) {
    commit("SET_OBJECT_STYLE_INITIAL")
    return true
  },
  async CLEAN_STORE_styles({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_styles", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_styles({ commit }, payload) {
    commit("SET_SELECTED_STYLES", payload)
    return true
  }
}
const mutations = {
  STYLES_SETTING: (state, { styles, count = false, page }) => {
    //console.log(state)
    state.count = count || state.styles.length
    state.page = page || state.page
    state.styles = styles
    state.fetched = true
    state.error = false
  },
  STYLES_ERROR: (state) => {
    state.styles = null
    state.fetched = true
    state.error = false

    state.dataShape = []
  },
  SET_OBJECT_STYLE: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_STYLE_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_STYLES: (state, selectedStyles) => {
    state.selected = selectedStyles
  },
  SET_styles: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
